import React from "react";

function Info() {
  return (
    <img
      src="https://advertflair-public.s3.us-west-2.amazonaws.com/assets/icons/info.svg"
      style={{ width: "32px" }}
      alt=""
    />
  );
}

export default Info;
